import { ReactElement, useState } from "react"

import { Button } from "@wfp/ui"

import { modaEditSteps } from "../../constants/markets"
import ProgressStepper from "../../components/Shared/ProgressStepper/ProgressStepper"
import SelectedFields from "../../components/Markets/ModaMapping/SelectedFields"

const ModaEditPage = (): ReactElement => {
  const [activeStep, setActiveStep] = useState<number>(2)

  const handleBack = (): void => {
    if (activeStep <= 2) return
    setActiveStep(activeStep - 1)
  }

  const handleNext = (): void => {
    if (activeStep > 3) return
    setActiveStep(activeStep + 1)
  }

  return (
    <div className="mx-4">
      <div className="w-full border-b-2 border-solid border-gray-200 pb-1 pt-2 sticky top-0 bg-white z-10">
        <ProgressStepper steps={modaEditSteps} currentStep={activeStep} />
      </div>

      <div className="mt-2 min-h-[52vh] px-4">{modaEditSteps[activeStep - 1].content}</div>

      <div className="flex justify-between align-center mt-4 w-full border-t-2 border-solid border-gray-200 pt-2 sticky bottom-0 bg-white z-10">
        <Button onClick={handleBack} disabled={activeStep <= 1}>
          Back
        </Button>
        <SelectedFields />
        {activeStep <= 3 ? <Button onClick={handleNext}>{activeStep >= 3 ? "Update" : "Global"}</Button> : <span />}
      </div>
    </div>
  )
}

export default ModaEditPage
